var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalDialog',{attrs:{"display-modal-dialog":!!_vm.liftToLegacy,"header":_vm.$t('liftToLegacyModal.thanks'),"message":_vm.$t('liftToLegacyModal.message'),"primary":_vm.$t('liftToLegacyModal.continue')},on:{"primary-clicked":_vm.goToLegacy}})
}
var staticRenderFns = []

export { render, staticRenderFns }